<template>
    <div class="form-group position-relative pb-4">
        <label v-if="label" for="icode">
            {{ label }}
        </label>
        <slot>
            <input
                v-model="modelValue"
                :type="type"
                class="form-control"
                :class="{'is-invalid': error}"
                :id="id"
                :disabled="disabled"
                :placeholder="placeholder" />
        </slot>
        <div v-if="error" class="text-danger position-absolute lh-1">
            <small>{{ error }}</small>
        </div>
    </div>
</template>

<script lang="ts" setup>
const modelValue = defineModel();
defineProps({
    id: {
        type: String,
        required: true,
    },
    type: {
        type: String,
        default: 'text',
    },
    placeholder: {
        type: String,
        default: '',
    },
    label: {
        type: String,
        required: false,
    },
    error: {
        type: String,
        required: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});
</script>
